import { deepMemoized } from './helpers';
import { wrappedAnalytics } from './setConfiguration';
import { setProps } from './setProps';
let previousTrackingProps;
export function sendBulkCommerce(events) {
  let formattedCommerceEvents;
  if (events.length) {
    formattedCommerceEvents = deepMemoized(events);
    if (!previousTrackingProps || formattedCommerceEvents !== previousTrackingProps) {
      previousTrackingProps = formattedCommerceEvents;
      formattedCommerceEvents.map(e => {
        if (e.data.customObject && Object.keys(e.data.customObject).length) {
          return setProps(e.data.customObject, {
            events: [e.name]
          });
        }
        return undefined;
      });
      wrappedAnalytics.sendEvents(formattedCommerceEvents);
    }
  }
}